import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import axios from "axios";
import Apiurl from "../../environment/Apiurl"; // Ensure this points to http://192.168.1.35:5000/api

const Charges = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [services, setServices] = useState([]);
  const [addform, setaddform] = useState({
    serviceName: "",
    hsnCode: "",
    basePrice: 0,
    GST_tax: 18,
  });
  const [updateform, setupdateform] = useState({
    serviceName: "",
    hsnCode: "",
    basePrice: 0,
    GST_tax: 18,
  });
  const [hsnCodes, setHsnCodes] = useState(""); // Changed to string for single HSN code
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [editService, setEditService] = useState(null);
  const [deleteServiceId, setDeleteServiceId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [privileges, setPrivileges] = useState(null);

  // Fetch privileges from localStorage
  useEffect(() => {
    const getAccess = localStorage.getItem("role");
    setPrivileges(getAccess);
  }, []);

  // Fetch services and HSN code on component mount
  useEffect(() => {
    fetchServices();
    // fetchHsnCodes();
  }, []);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional for smooth scrolling
    });
  }, []);

  // Prepopulate updateform when editService changes
  useEffect(() => {
    if (editService) {
      setupdateform({
        serviceName: editService.serviceName || "",
        hsnCode: editService.hsnCode || "",
        basePrice: editService.basePrice || 0,
        GST_tax: editService.GST_tax || 0,
      });
    }
  }, [editService]);

  // Update addform when hsnCodes changes
  // useEffect(() => {
  //   setaddform((prev) => ({
  //     ...prev,
  //     hsnCode: hsnCodes,
  //   }));
  // }, [hsnCodes]);

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${Apiurl}/service`, { timeout: 5000 });
      setServices(response.data.reverse() || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching services:", error);
      setError("Failed to fetch services. Please try again.");
      setLoading(false);
    }
  };

  // const fetchHsnCodes = async () => {
  //   try {
  //     setLoading(true);
  //     setError(null);
  //     const response = await axios.get(`${Apiurl}/hsn_code`, { timeout: 5000 });
  //     const hsnCode = response.data.hsnCode || "";
  //     if (typeof hsnCode !== "string") {
  //       throw new Error("Invalid HSN code data format");
  //     }
  //     setHsnCodes(hsnCode);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching HSN code:", error);
  //     setError(error.response?.data?.message || "Failed to fetch HSN code. Please try again.");
  //     setLoading(false);
  //   }
  // };

  const handleCloseAddModal = () => {
    setShowAddModal(false);
    setaddform({
      serviceName: "",
      hsnCode: "", // Keep fetched HSN code
      basePrice: 0,
      GST_tax: 18,
    });
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditService(null);
    setupdateform({
      serviceName: "",
      hsnCode: "",
      basePrice: 0,
      GST_tax: 18,
    });
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteServiceId(null);
  };

  const handleAddFormChange = (e) => {
    const { name, value } = e.target;
    setaddform((prev) => ({
      ...prev,
      [name]:
        name === "basePrice" || name === "GST_tax"
          ? parseFloat(value) || 0
          : value,
    }));
  };

  const handleUpdateFormChange = (e) => {
    const { name, value } = e.target;
    setupdateform((prev) => ({
      ...prev,
      [name]:
        name === "basePrice" || name === "GST_tax"
          ? parseFloat(value) || 0
          : value,
    }));
  };

  const handleAddService = async (e) => {
    e.preventDefault();
    if (isNaN(addform.basePrice) || isNaN(addform.GST_tax)) {
      setError("Please enter valid numbers for Base Price and GST.");
      return;
    }
    if (!addform.hsnCode) {
      setError("HSN code is required.");
      return;
    }
    try {
      const response = await axios.post(`${Apiurl}/service`, addform);
      setServices([...services, response.data]);
      handleCloseAddModal();
    } catch (error) {
      console.error("Error adding service:", error);
      setError("Failed to add service. Please try again.");
    }
  };

  const handleEditService = async (e) => {
    e.preventDefault();
    if (isNaN(updateform.basePrice) || isNaN(updateform.GST_tax)) {
      setError("Please enter valid numbers for Base Price and GST.");
      return;
    }
    try {
      const response = await axios.put(
        `${Apiurl}/service/${editService._id}`,
        updateform
      );
      setServices(
        services.map((service) =>
          service._id === editService._id ? response.data : service
        )
      );
      handleCloseEditModal();
    } catch (error) {
      console.error("Error updating service:", error);
      setError("Failed to update service. Please try again.");
    }
  };

  const handleDeleteService = (id) => {
    setDeleteServiceId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`${Apiurl}/service/${deleteServiceId}`);
      setServices(
        services.filter((service) => service._id !== deleteServiceId)
      );
      handleCloseDeleteModal();
    } catch (error) {
      console.error("Error deleting service:", error);
      setError("Failed to delete service. Please try again.");
    }
  };

  // Filter services based on search term
  const filteredServices = services.filter(
    (service) =>
      service.serviceName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      service.hsnCode?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem =
    itemsPerPage === "All"
      ? filteredServices.length
      : currentPage * parseInt(itemsPerPage);
  const indexOfFirstItem =
    itemsPerPage === "All" ? 0 : indexOfLastItem - parseInt(itemsPerPage);
  const currentServices = filteredServices.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages =
    itemsPerPage === "All"
      ? 1
      : Math.ceil(filteredServices.length / parseInt(itemsPerPage));

  const getPageList = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const pages = getPageList();

  const handlePageClick = (page) => {
    if (page !== "..." && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  if (loading) {
    return (
      <div
        className="container-fluid p-3 d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-3">
      {error && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {error}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError(null)}
          ></button>
        </div>
      )}

      <div className="d-flex justify-content-end mb-3">
        {(privileges === "Admin" ||
          privileges === "Manager" ||
          privileges === "Receptionist") && (
          <button
            className="btn btn-sm text-white"
            style={{ backgroundColor: "#2e9290" }}
            onClick={() => setShowAddModal(true)}
          >
            <FaPlus className="me-2" />
            Add Charges
          </button>
        )}
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row mb-2">
            <div className="col-md-2">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-table"></i>
                </span>
                <select
                  className="form-select"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setItemsPerPage(e.target.value);
                  }}
                >
                  <option value="All">Show All</option>
                  {[5, 10, 20, 50, 100].map((n) => (
                    <option key={n} value={n}>
                      Show {n}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-7"></div>
            <div className="col-md-3">
              <div className="d-flex align-items-center">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control pe-5"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <FaSearch
                    className="text-muted"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    S.No
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Service Name
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    HSN Code
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Base Price ($)
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    GST (%)
                  </th>
                  <th style={{ backgroundColor: "#2e9290", color: "white" }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentServices.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      {searchTerm
                        ? "No services found matching your search"
                        : "No services available"}
                    </td>
                  </tr>
                ) : (
                  currentServices.map((service, index) => (
                    <tr key={service._id} className="align-middle">
                      <td>
                        {itemsPerPage === "All"
                          ? index + 1
                          : (currentPage - 1) * parseInt(itemsPerPage) +
                            index +
                            1}
                      </td>
                      <td>{service.serviceName}</td>
                      <td>{service.hsnCode}</td>
                      <td>{service.basePrice}</td>
                      <td>{service.GST_tax}</td>
                      <td>
                        {(privileges === "Admin" ||
                          privileges === "Manager") && (
                          <button
                            className="btn btn-sm border-0 me-1"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => {
                              setEditService(service);
                              setShowEditModal(true);
                            }}
                          >
                            <FaEdit className="text-info" />
                          </button>
                        )}
                        {privileges === "Admin" && (
                          <button
                            className="btn btn-sm border-0"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => handleDeleteService(service._id)}
                          >
                            <FaTrash className="text-danger" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="container">
              <div className="d-flex justify-content-between align-items-center p-3 border-top gap-2">
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() => handlePageClick(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <i className="fas fa-chevron-left"></i>
                  <span className="d-none d-sm-inline">Previous</span>
                </button>
                <div
                  className="d-flex overflow-auto flex-nowrap gap-2 px-2"
                  style={{ maxWidth: "100%" }}
                >
                  {pages.map((page, index) => (
                    <button
                      key={index}
                      className={`btn btn-sm px-3 flex-shrink-0 ${
                        page === currentPage
                          ? "text-white"
                          : "btn-outline-secondary"
                      }`}
                      style={
                        page === currentPage
                          ? { backgroundColor: "#2e9290", border: "none" }
                          : {}
                      }
                      onClick={() => handlePageClick(page)}
                      disabled={page === "..."}
                    >
                      {page}
                    </button>
                  ))}
                </div>
                <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2"
                  onClick={() => handlePageClick(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <span className="d-none d-sm-inline">Next</span>
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add Service Modal */}
      {showAddModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Add Charges</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseAddModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  padding: "15px",
                }}
              >
                <form onSubmit={handleAddService}>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label">Service Name</label>
                      <input
                        type="text"
                        name="serviceName"
                        className="form-control form-control-sm"
                        placeholder="e.g., Screen Replacement"
                        value={addform.serviceName}
                        onChange={handleAddFormChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">HSN Code</label>
                      <input
                        type="text"
                        name="hsnCode"
                        className="form-control form-control-sm"
                        value={addform.hsnCode}
                        onChange={handleAddFormChange}
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label">Base Price ($)</label>
                      <input
                        type="tel"
                        name="basePrice"
                        className="form-control form-control-sm"
                        value={addform.basePrice}
                        onChange={handleAddFormChange}
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">GST (%)</label>
                      <input
                        type="tel"
                        name="GST_tax"
                        className="form-control form-control-sm"
                        value={addform.GST_tax}
                        onChange={handleAddFormChange}
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={handleCloseAddModal}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm"
                      style={{ backgroundColor: "#2e9290", border: "none" }}
                    >
                      Add Charges
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Service Modal */}
      {showEditModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Edit Charges</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseEditModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  padding: "15px",
                }}
              >
                <form onSubmit={handleEditService}>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label">Service Name</label>
                      <input
                        type="text"
                        name="serviceName"
                        className="form-control form-control-sm"
                        value={updateform.serviceName}
                        onChange={handleUpdateFormChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">HSN Code</label>
                      <input
                        name="hsnCode"
                        className="form-control form-control-sm"
                        value={updateform.hsnCode}
                        onChange={handleUpdateFormChange}
                        required
                      ></input>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label">Base Price ($)</label>
                      <input
                        type="tel"
                        name="basePrice"
                        className="form-control form-control-sm"
                        value={updateform.basePrice}
                        onChange={handleUpdateFormChange}
                        min="0"
                        step="0.01"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">GST (%)</label>
                      <input
                        type="tel"
                        name="GST_tax"
                        className="form-control form-control-sm"
                        value={updateform.GST_tax}
                        onChange={handleUpdateFormChange}
                        min="0"
                        step="0.01"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={handleCloseEditModal}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm"
                      style={{ backgroundColor: "#2e9290", border: "none" }}
                    >
                      Update Service
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseDeleteModal}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete{" "}
                  {services.find((s) => s._id === deleteServiceId)?.serviceName}
                  ?
                </p>
                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Charges;






